import type { NavItem, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Longhand',
    tagline: 'Written slowly, read carefully.',
    description: 'Thoughtful essays and practical guides on design, travel, food and culture, for people who would rather read one good thing than skim twenty.',
    url: getOrigin()
}

export const mainNav: NavItem[] = [
    { label: 'Stories', href: '/blog' },
    { label: 'Topics', href: '/topics' },
    { label: 'Authors', href: '/authors' },
    { label: 'About', href: '/about' }
]

export const POSTS_PER_PAGE = 9
